// extracted by mini-css-extract-plugin
module.exports = {"scope":"sticky-offset_scope__rNiwg"};